import { render, staticRenderFns } from "./PromotionModule1.vue?vue&type=template&id=6cd779ff&scoped=true"
import script from "./PromotionModule1.vue?vue&type=script&lang=js"
export * from "./PromotionModule1.vue?vue&type=script&lang=js"
import style0 from "./PromotionModule1.vue?vue&type=style&index=0&id=6cd779ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd779ff",
  null
  
)

export default component.exports